'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _pure = require('recompose/pure');

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = require('../../SvgIcon');

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ActionPermScanWifi = function ActionPermScanWifi(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M12 3C6.95 3 3.15 4.85 0 7.23L12 22 24 7.25C20.85 4.87 17.05 3 12 3zm1 13h-2v-6h2v6zm-2-8V6h2v2h-2z' })
  );
};
ActionPermScanWifi = (0, _pure2.default)(ActionPermScanWifi);
ActionPermScanWifi.displayName = 'ActionPermScanWifi';
ActionPermScanWifi.muiName = 'SvgIcon';

exports.default = ActionPermScanWifi;


//////////////////
// WEBPACK FOOTER
// ./~/material-ui/svg-icons/action/perm-scan-wifi.js
// module id = 1867
// module chunks = 0